import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

export default function ForgotPassword() {
  const { t } = useApp();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-5 py-16" data-testid="forgot-page">
      <div className="flex items-center gap-2 text-[#002FA7]"><KeyRound size={22} /><span className="text-xs font-bold uppercase tracking-[0.2em]">{t("forgot_title")}</span></div>
      <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight">{t("forgot_title")}</h1>
      <p className="mt-2 text-sm text-gray-500">{t("forgot_sub")}</p>
      {sent ? (
        <div data-testid="forgot-sent" className="mt-8 rounded-2xl bg-[#155724]/10 p-5 text-sm font-semibold text-[#155724]">{t("forgot_sent")}</div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="forgot-form">
          <input data-testid="forgot-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("your_email")} className="w-full rounded-xl border border-gray-200 px-4 py-2.5 outline-none focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20" />
          <button data-testid="forgot-submit" disabled={busy} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#002FA7] py-3 text-sm font-bold text-white disabled:opacity-60">{busy && <Loader2 size={15} className="animate-spin" />} {t("forgot_send")}</button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-gray-500"><Link to="/login" data-testid="forgot-back" className="font-bold text-[#002FA7]">{t("back_to_login")}</Link></p>
    </div>
  );
}
